<template>
  <v-card
    v-if="viewData"
    flat
  >
    <v-card-title class="py-0 px-0">
      <v-toolbar
        :height="$vuetify.breakpoint.xsOnly ? 44 : 60"
        class="filter-toolbar"
        flat
      >
        <v-btn
          v-if="userCanAdd"
          :color="$t('Marketing.Print.ListView.Button.Add.Color')"
          :icon="$vuetify.breakpoint.xsOnly"
          class="elevation-0 ma-1"
          text
          @click="showAddTemplateDialog"
        >
          <v-icon :left="$vuetify.breakpoint.smAndUp">
            {{ $t('Marketing.Print.ListView.Button.Add.Icon') }}
          </v-icon>&nbsp;
          <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('Marketing.Print.ListView.Button.Add.Title') }}</span>
        </v-btn>

        <!--
        <v-btn
          v-if="userIsSuperAdmin && posUser.staff_email === 'v.gerogiannis@gmail.com'"
          :color="$t('Marketing.Print.ListView.Button.Add.Color')"
          :icon="$vuetify.breakpoint.xsOnly"
          class="elevation-0 ma-1"
          text
          @click="showAddTemplateDialog2"
        >
          <v-icon :left="$vuetify.breakpoint.smAndUp">
            {{ $t('Marketing.Print.ListView.Button.Add.Icon') }}
          </v-icon>&nbsp;
          <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('Marketing.Print.ListView.Button.Add.Title') }}</span>
        </v-btn>
        -->

        <v-btn
          v-if="posUserHasComponentPermission('KitchenMenu', 'ACCESS')"
          :color="$t('Restaurant.Categories.Toolbar.Button.Products.Color')"
          :icon="$vuetify.breakpoint.xsOnly"
          :to="{name: 'KitchenMenu'}"
          class="elevation-0 ma-1"
          text
        >
          <v-icon
            v-if="$t('Restaurant.Categories.Toolbar.Button.Products.Icon')"
            :left="$vuetify.breakpoint.smAndUp"
          >
            {{ $t('Restaurant.Categories.Toolbar.Button.Products.Icon') }}
          </v-icon>&nbsp;
          <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('Restaurant.Categories.Toolbar.Button.Products.Title').toLocaleUpperCase($i18n.locale) }}</span>
        </v-btn>

        <v-spacer />

        <filter-search v-model="dataTable.search.terms" />
      </v-toolbar>
    </v-card-title>

    <v-container
      class="pa-0"
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-data-table
            :footer-props="dataTable.footerProps"
            :headers="dataTableHeaders"
            :height="dataTable.resize.bodyHeight"
            :items="dataTable.data"
            :loading="dataTable.loading"
            :loading-text="dataTable.text.loadingText"
            :no-data-text="dataTable.text.noDataText"
            :no-results-text="dataTable.text.noResultsText"
            :options.sync="dataTable.options"
            :search="dataTable.search.terms"
            :server-items-length="dataTable.total"
            fixed-header
            item-key="Id"
          >
            <template #[`item.image`]="{item}">
              <img
                :src="item.Image"
                class="mt-3 mb-1"
                width="100"
              >
            </template>

            <template #[`item.id`]="{item}">
              {{ item.Id }}
            </template>

            <template #[`item.name`]="{item}">
              {{ item.Title }}
            </template>

            <template #[`item.products`]="{item}">
              <v-chip
                label
                small
              >
                {{ formatDecimal($i18n.locale, item.Products, 0) }}
              </v-chip>
            </template>

            <template #[`item.created_at`]="{item}">
              {{ item.CreatedAt }}
            </template>

            <template #[`item.actions`]="{item}">
              <template v-if="userCanAccess">
                <v-tooltip
                  :color="$t('Marketing.Print.ListView.Button.Preview.Color')"
                  :open-delay="1000"
                  top
                >
                  <template #activator="{on}">
                    <v-btn
                      :class="item.loading || item.loadingPreview ? 'grey' : $t('Marketing.Print.ListView.Button.Preview.Color')"
                      :disabled="item.loading || item.loadingPreview"
                      :loading="item.loadingPreview"
                      :small="$vuetify.breakpoint.xsOnly"
                      class="elevation-2 ma-1"
                      dark
                      icon
                      @click="previewTemplate(item)"
                      v-on="on"
                    >
                      <v-icon>{{ $t('Marketing.Print.ListView.Button.Preview.Icon') }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Marketing.Print.ListView.Button.Preview.Title') }}</span>
                </v-tooltip>
              </template>

              <template v-if="userCanAdd || userCanManage">
                <v-tooltip
                  :color="$t('Marketing.Print.ListView.Button.Edit.Color')"
                  :open-delay="1000"
                  top
                >
                  <template #activator="{on}">
                    <v-btn
                      :class="item.loading || item.loadingEdit ? 'grey' : $t('Marketing.Print.ListView.Button.Edit.Color')"
                      :disabled="item.loading || item.loadingEdit"
                      :loading="item.loadingEdit"
                      :small="$vuetify.breakpoint.xsOnly"
                      class="elevation-2 ma-1"
                      dark
                      icon
                      @click="editTemplate(item)"
                      v-on="on"
                    >
                      <v-icon>{{ $t('Marketing.Print.ListView.Button.Edit.Icon') }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Marketing.Print.ListView.Button.Edit.Title') }}</span>
                </v-tooltip>

                <v-tooltip
                  :color="$t('Marketing.Print.ListView.Button.Duplicate.Color')"
                  :open-delay="1000"
                  top
                >
                  <template #activator="{on}">
                    <v-btn
                      :class="item.loading || item.loadingDuplicate ? 'grey' : $t('Marketing.Print.ListView.Button.Duplicate.Color')"
                      :disabled="item.loading || item.loadingDuplicate"
                      :loading="item.loadingDuplicate"
                      :small="$vuetify.breakpoint.xsOnly"
                      class="elevation-2 ma-1"
                      dark
                      icon
                      @click="duplicateTemplate(item)"
                      v-on="on"
                    >
                      <v-icon>{{ $t('Marketing.Print.ListView.Button.Duplicate.Icon') }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Marketing.Print.ListView.Button.Duplicate.Title') }}</span>
                </v-tooltip>
              </template>

              <template v-if="userCanDelete">
                <v-tooltip
                  :color="$t('Marketing.Print.ListView.Button.Delete.Color')"
                  :open-delay="1000"
                  top
                >
                  <template #activator="{on}">
                    <v-btn
                      :class="!!item.DeletedAt || item.loading || item.loadingDelete || item.Products > 0 ? 'grey' : $t('Marketing.Print.ListView.Button.Delete.Color')"
                      :disabled="!!item.DeletedAt || item.loading || item.loadingDelete || item.Products > 0"
                      :loading="item.loadingDelete"
                      :small="$vuetify.breakpoint.xsOnly"
                      class="elevation-2 ma-1"
                      dark
                      icon
                      @click="deleteTemplate(item)"
                      v-on="on"
                    >
                      <v-icon>{{ $t('Marketing.Print.ListView.Button.Delete.Icon') }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Marketing.Print.ListView.Button.Delete.Title') }}</span>
                </v-tooltip>
              </template>
            </template>

            <template #no-data>
              <v-data-table-no-data
                :button-callback="showAddTemplateDialog"
                :no-data-obj="$t('Marketing.Print.ListView.Table.NoData')"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <print-template-edit-dialog
      v-if="selectedTemplate"
      :template="selectedTemplate"
      :visible.sync="addTemplateDialogVisible"
    />

    <!--
    <print-template-edit-dialog2
      v-if="selectedTemplate"
      :template="selectedTemplate"
      :visible.sync="addTemplateDialogVisible2"
    />
    -->

    <print-template-preview-dialog
      v-if="selectedTemplate"
      :template="selectedTemplate"
      :visible.sync="previewTemplateDialogVisible"
    />

    <confirm-dialog
      v-if="selectedTemplate"
      :html-content="$t('Marketing.Print.ListView.ConfirmDeleteDialog.Content', {title: selectedTemplate.Title})"
      :html-title="$t('Marketing.Print.ListView.ConfirmDeleteDialog.Title')"
      :info-bar="true"
      :info-bar-body="$t('Marketing.Print.ListView.ConfirmDeleteDialog.Warning')"
      :visible.sync="confirmDialogDeleteVisible"
      :width="560"
      no-button-class="v-btn--outline green--text"
      title-class="red white--text lighten-0"
      yes-button-class="red white--text"
      yes-button-event="on-confirm-delete"
      @on-confirm-delete="onConfirmDeleteTemplate"
    />
  </v-card>
</template>

<script>
import AppData from '@/mixins/appdata.js'
import Auth from '@/mixins/auth.js'
import DataTable from '@/mixins/data-table/dataTable.js'
import FilterSearch from '@/components/common/filter/FilterSearch.vue'
import VDataTableNoData from '@/components/common/data-table/VDataTableNoData.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import PrintTemplatePreviewDialog from '@/components/marketing/print/PrintTemplatePreviewDialog.vue'
import PrintTemplateEditDialog from '@/components/marketing/print/PrintTemplateEditDialog.vue'
import PrintTemplateEditDialog2 from '@/components/marketing/print/PrintTemplateEditDialog.vue'
import capitalize from '@/filters/string/capitalize.js'
import {formatDecimal} from '@/lib/currency/currency.js'

export default {
  Name      : 'Print',
  components: {
    PrintTemplatePreviewDialog,
    PrintTemplateEditDialog2,
    PrintTemplateEditDialog,
    ConfirmDialog,
    VDataTableNoData,
    FilterSearch
  },
  directives: {},
  mixins    : [AppData, Auth, DataTable],
  data() {
    return {
      selectedTemplate            : null,
      addTemplateDialogVisible    : false,
      addTemplateDialogVisible2   : false,
      previewTemplateDialogVisible: false,
      templatesDialogVisible      : false,
      confirmDialogDeleteVisible  : false,

      dataTable: {
        socketCommand: {
          list: window.SocketCommand.Marketing.Print.All
        },
        options: {
          defaultSortBy: 'id',
          sortBy       : ['id'],
          sortDesc     : [true]
        },
        rejectHeaders: {
          xsOnly   : [],
          smAndDown: [],
          mdAndDown: [],
          lgAndDown: [],
          xlAndDown: []
        },
        headers: [
          {
            text     : '',
            value    : 'image',
            align    : 'center',
            sortable : false,
            cellClass: 'text-caption',
            width    : 200
          },
          {
            text     : this.$t('Marketing.Print.ListView.Table.Headers.Id'),
            value    : 'id',
            align    : 'right',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Print.ListView.Table.Headers.Name'),
            value    : 'name',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Print.ListView.Table.Headers.Products'),
            value    : 'products',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Print.ListView.Table.Headers.CreatedAt'),
            value    : 'created_at',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Print.ListView.Table.Headers.Actions'),
            value    : 'actions',
            align    : 'right',
            sortable : false,
            cellClass: 'text-caption px-2',
            width    : 200
          }
        ]
      }
    }
  },
  computed: {},
  watch   : {},
  created() {
    this.$bus.$on(window.SocketCommand.Marketing.Print.Get, this.onGetTemplateResult)
    this.$bus.$on(window.SocketCommand.Marketing.Print.Save, this.onSaveTemplateResult)
    this.$bus.$on(window.SocketCommand.Marketing.Print.Delete, this.onDeleteTemplateResult)
    this.$bus.$on(window.SocketCommand.Marketing.Print.Duplicate, this.onDuplicateTemplateResult)
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(window.SocketCommand.Marketing.Print.Get, this.onGetTemplateResult)
    this.$bus.$off(window.SocketCommand.Marketing.Print.Save, this.onSaveTemplateResult)
    this.$bus.$off(window.SocketCommand.Marketing.Print.Delete, this.onDeleteTemplateResult)
    this.$bus.$off(window.SocketCommand.Marketing.Print.Duplicate, this.onDuplicateTemplateResult)
  },
  methods: {
    formatDecimal,
    previewTemplate(template) {
      if (!template) return
      this.setTemplateLoading(template, 'preview', true)
      this.getTemplate(template, 'preview')
    },

    duplicateTemplate(template) {
      if (!template) return
      this.setTemplateLoading(template, 'duplicate', true)
      window.callAS(window.SocketCommand.Marketing.Print.Duplicate, {Id: template.Id})
      this.selectedTemplate = null
    },
    onDuplicateTemplateResult(result, payload) {
      if (result?.status === 'success') {
        this.getData()
      } else {
        this.setTemplateLoading(this.getDataTableTemplate(payload?.Id), 'duplicate', false)
      }
    },

    editTemplate(template) {
      if (!template) return
      this.setTemplateLoading(template, 'edit', true)
      this.getTemplate(template, 'edit')
    },

    getTemplate(template, type, returnCommand) {
      if (!template) return
      window.callAS(window.SocketCommand.Marketing.Print.Get, {Id: template.Id, Type: type}, returnCommand)
    },
    onGetTemplateResult(result, payload) {
      this.setTemplateLoading(this.getDataTableTemplate(payload?.Id), payload?.Type, false)

      if (result?.data && result?.status === 'success') {
        this.selectedTemplate = result.data

        this.$nextTick(() => {
          if (payload?.Type === 'edit') this.showEditTemplateDialog()
          if (payload?.Type === 'preview') this.showPreviewTemplateDialog()
        })
      }
    },

    onSaveTemplateResult(result, payload) {
      if (result?.status === 'success') {
        this.getData()
      }
    },

    deleteTemplate(template) {
      if (!template) return
      this.selectedTemplate = template
      this.confirmDialogDeleteVisible = true
    },
    onConfirmDeleteTemplate() {
      const template = this.selectedTemplate
      this.setTemplateLoading(template, 'delete', true)
      window.callAS(window.SocketCommand.Marketing.Print.Delete, {Id: template.Id})
      this.selectedTemplate = null
    },
    onDeleteTemplateResult(result, payload) {
      if (result?.status === 'success') {
        this.getData()
      } else {
        this.setTemplateLoading(this.getDataTableTemplate(payload?.Id), 'delete', false)
      }
    },

    setTemplateLoading(template, event, loading = false) {
      if (!template) return
      this.$set(template, 'loading', loading)
      if (event) this.$set(template, `loading${capitalize(event || '')}`, loading)
    },

    getDataTableTemplate(templateId) {
      return this.dataTable?.data?.find(template => template.Id === templateId)
    },

    showPreviewTemplateDialog() {
      if (!this.selectedTemplate) return
      this.previewTemplateDialogVisible = true
    },

    showAddTemplateDialog2() {
      this.selectedTemplate = {
        Subject : '',
        Body    : '',
        BodyText: '',
        Source  : '',
        Type    : 'print'
      }

      this.addTemplateDialogVisible2 = true
    },

    showAddTemplateDialog() {
      this.selectedTemplate = {
        Subject : '',
        Body    : '',
        BodyText: '',
        Source  : '',
        Type    : 'print'
      }

      this.addTemplateDialogVisible = true
    },

    showEditTemplateDialog() {
      if (!this.selectedTemplate) return
      this.addTemplateDialogVisible = true
    }
  }
}
</script>

<style scoped>
:deep(.filter-toolbar .v-toolbar__content) {
  padding: 0 6px;
}

:deep(.v-input--selection-controls.v-input--switch) {
  display: inline-block;
  position: relative !important;
  /*width    : 75px !important;*/
}

:deep(.v-input--selection-controls.v-input--switch label) {
  font-size: 12px !important;
  padding-right: 0;
  margin: 0;
}

:deep(.v-data-table > .v-data-table__wrapper > table:has(tbody tr:first-child.v-data-table__empty-wrapper)) {
  width: 100%;
  height: 100%;
  border-spacing: 0;
}
</style>
